module.exports = __webpack_public_path__ + "img/taiwan.3c30dfe3.png";